import { ReactNode, useCallback, useContext, useEffect, useMemo, useState } from 'react';

import { AccountContext } from '@/context/AccountContext';
import { GlobalLoginContext } from '@/context/GlobalLoginContest';

export const AccountProvider = ({ children }: { children: ReactNode }) => {
  const [account, setAccount] = useState<any>(null);
  const { isLogin } = useContext(GlobalLoginContext);

  const getAccount = () => {
    import('@/request/login').then(({ getAccountInfo }) => {
      getAccountInfo().then((res) => {
        setAccount(res);
      });
    });
  };

  const memorizedClearAccount = useCallback(() => {
    setAccount(null);
  }, []);

  useEffect(() => {
    if (window?.location?.pathname?.includes('app/captcha')) {
      return;
    }
    if (isLogin) {
      if (window.requestIdleCallback) {
        window.requestIdleCallback(() => {
          getAccount();
        });
      } else {
        setTimeout(() => {
          getAccount();
        }, 300);
      }
    }
  }, [isLogin]);

  const memorizedValues = useMemo(() => {
    return { account, clearAccount: memorizedClearAccount };
  }, [account, memorizedClearAccount]);

  return <AccountContext.Provider value={memorizedValues}>{children}</AccountContext.Provider>;
};
